// Runtime build identity from index.html's <meta> tags. The deploy substitutes the
// __BUILD_*__ placeholders AFTER the Nx-cached build, so these values never enter
// the cache key. Unsubstituted (local dev) reads as undefined, leaving every
// version-awareness feature dormant off-prod.

import { readBuildMeta, readBuildMetaNumber } from '@maat/utils';

export interface BuildInfo {
    /** Git commit SHA — the "which deployment is live" id. */
    readonly sha?: string;
    readonly version?: string;
    /** Monotonic CI build number — the orderable id for the min-version gate. */
    readonly buildNumber?: number;
}

export const buildInfo: BuildInfo = {
    sha: readBuildMeta('build-sha'),
    version: readBuildMeta('build-version'),
    buildNumber: readBuildMetaNumber('build-number'),
};
